import { lineChartOptions, xTimeScaleOptions } from "~/misc/charts";
import { Chart, TooltipItem } from "chart.js";
import moment from "moment";

export class ChartTemperature extends Chart<"line"> {
  uniq_id: string;
  timer: number | null = null;

  constructor(canvas_id: string, uniq_id: string) {
    const ctx = $(canvas_id)[0] as HTMLCanvasElement;
    const options = Object.assign({}, lineChartOptions);
    options.scales = {
      x: { type: 'time', time: xTimeScaleOptions },
      y: {
        min: 0,
        suggestedMax: 20,
        title: {
          display: true,
          text: 'Hőmérséklet [°C]'
        }
      }
    };
    options.plugins = {
      tooltip: {
        callbacks: {
          label: function (tooltipItem: TooltipItem<'line'>) {
            const { x, y } = tooltipItem.raw as { x: number, y: number; };
            return Math.round(y).toFixed(1) + ' °C';
          }
        }
      },
      zoom: {
        pan: {
          enabled: true,
          mode: 'x'
          //modifierKey: 'ctrl'
        },
        zoom: {
          wheel: { enabled: true },
          pinch: { enabled: true },
          mode: 'x'
          // drag: true // uncomment if you want drag zoom
        },
        limits: {
          x: {
            minRange: 30 * 60 * 1000
          }
        }
      },
      legend: {
        onClick: function (event, legendItem, legend) {
          const index = legendItem.datasetIndex!;
          const ci = legend.chart;
          if (ci.isDatasetVisible(index)) {
            ci.hide(index);
            legendItem.hidden = true;
          } else {
            ci.show(index);
            legendItem.hidden = false;
          }
          // Save to localStorage
          const key = `ch_${uniq_id}`;
          const stored = JSON.parse(localStorage.getItem(key) || '{}');
          stored[index] = legendItem.hidden;
          localStorage.setItem(key, JSON.stringify(stored));
        }
      }
    };

    super(ctx, {
      type: 'line',
      data: {
        datasets: [],
      },
      options: options
    });

    this.uniq_id = uniq_id;

    (this.options.plugins as any).zoom.pan.onPanComplete = () => this.startFetch();
    (this.options.plugins as any).zoom.zoom.onZoomComplete = () => this.startFetch();

    this.startFetch();



    $('#btnDownload').on('click', () => {
      $(this).blur();
      const min = this.scales.x.min;
      const max = this.scales.x.max;
      const url = location.href + "/fetch.json?export=1&min=" + moment(min).format() + "&max=" + moment(max).format();
      //window.open(url, '_blank').focus();
      var a = document.createElement('a');
      a.href = url;
      a.download = "export.json";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    });

  }

  startFetch = () => {
    const min = this.scales.x.min;
    const max = this.scales.x.max;
    if (this.timer) clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      console.log('Fetched data between ' + moment(min).format() + ' and ' + moment(max).format());
      $.ajax({
        url: location.href + "/fetch",
        type: "GET",
        data: {
          min: moment(min).format(),
          max: moment(max).format()
        },
        dataType: "json",
        success: (response) => {
          this.data.datasets = response;
          const key = `ch_${this.uniq_id}`;
          const stored = JSON.parse(localStorage.getItem(key) || '{}');
          this.data.datasets.forEach((ds: any, idx: number) => {
            if (stored[idx]) {
              ds.hidden = true;
            }
          });
          this.stop();
          // make sure animations are not running
          this.update('none');
        }
      });
    }, 500);
  };
}